import React from "react";
import { View } from "components/utils/View";
import { viewOptionSelector } from "~redux/slices/viewOptionSlice";
import { CpdlcMsgOut as BaseCpdlcMsgOut, cpdlcMsgOutView, cpdlcTocHeldView } from "@poscon/shared-frontend";
import { useRootDispatch, useRootSelector } from "~redux/hooks";
import { ViewOptionContextProvider } from "contexts/viewOptionContext";
import { setAsel } from "~/redux/slices/eramTempStateSlice";

export const CpdlcMsgOut = () => {
  const dispatch = useRootDispatch();
  const viewOptions = useRootSelector((state) => viewOptionSelector(state, cpdlcMsgOutView));

  return (
    <ViewOptionContextProvider options={viewOptions}>
      <BaseCpdlcMsgOut
        ViewComponent={View}
        openTocMenu={(fpId) => dispatch(setAsel({ fpId, menu: cpdlcTocHeldView }))}
      />
    </ViewOptionContextProvider>
  );
};
